/**
 * Đọc **tin mới** từ một website đã khai — phần thuần, không chạm mạng.
 *
 * Lynust chốt 10/09/2026: *"chỉ research các tin mới liên quan đến y tế trong các website đã chỉ
 * định"*. Không tìm kiếm mở ⇒ **không có phí web search**, và đề bài của Luồng 3 đến từ đây.
 *
 * **Chỉ đọc feed và sitemap. Không bò trang HTML.**
 *
 * Cám dỗ là quét `<a href>` của trang chủ để "chắc ăn có tin". Không làm, vì ba lý do đo được:
 * một trang chủ có hàng trăm liên kết điều hướng lẫn với tin; không phân biệt được bài mới với
 * bài cũ nằm ở khối "xem thêm"; và mỗi lượt quét là một lần đọc nhầm menu thành chủ đề nghiên
 * cứu y tế. Không tìm thấy feed là **một kết quả hợp lệ** — báo ra, đừng lấp bằng thứ tệ hơn.
 */
/**
 * Đường dẫn feed hay gặp, thử theo đúng thứ tự này.
 *
 * `sitemap.xml` đứng **cuối**: nó liệt kê cả trang tĩnh lẫn bài, và thường không có tiêu đề. Feed
 * thật luôn tốt hơn — nó đã tự chọn ra "cái gì là tin".
 */
export const DUONG_FEED_HAY_GAP = [
    "/feed",
    "/rss",
    "/rss.xml",
    "/feed.xml",
    "/atom.xml",
    "/index.xml",
    "/news/rss",
    "/sitemap.xml",
];
/* ── Gỡ XML bằng tay, không thêm một gói phụ thuộc ────────────────────── */
/** Gỡ CDATA và bốn thực thể XML bắt buộc. Đủ cho feed; không phải một bộ phân tích HTML. */
export function goChu(tho) {
    return tho
        .replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, "$1")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#0?39;|&apos;/g, "'")
        .replace(/&nbsp;/g, " ")
        // `&amp;` **sau cùng**: làm trước thì `&amp;lt;` thành `<` — một lỗi giải mã hai lần.
        .replace(/&amp;/g, "&")
        .replace(/\s+/g, " ")
        .trim();
}
function lay(khoi, the) {
    const m = khoi.match(new RegExp(`<${the}(?:\\s[^>]*)?>([\\s\\S]*?)</${the}>`, "i"));
    return m?.[1] === undefined ? null : goChu(m[1]);
}
/**
 * Liên kết của một mục.
 *
 * RSS để URL trong thân `<link>`; Atom để trong thuộc tính `href` của một thẻ tự đóng, và có thể
 * có **nhiều** `<link>` với `rel` khác nhau — `alternate` mới là bài, `self`/`edit` thì không.
 */
/**
 * Bỏ những khối **chứa HTML của bài** trước khi đi tìm thẻ cấu trúc.
 *
 * ⚠️ `<content:encoded>` và `<description>` mang nguyên thân bài trong CDATA, và thân bài có
 * `<link rel="stylesheet">`, `<a>`, `<img>`. Tìm `<link>` trên XML thô nghĩa là **lấy một thẻ
 * của bài viết làm URL của bài viết** — item đó bị bỏ im lặng, không lỗi nào nổ.
 *
 * Đo được 10/09/2026: một item có `<content:encoded>` đứng TRƯỚC `<link>` thật trả về rỗng.
 */
function boThanBai(khoi) {
    return khoi
        .replace(/<content:encoded\b[\s\S]*?<\/content:encoded>/gi, "")
        .replace(/<description\b[\s\S]*?<\/description>/gi, "")
        .replace(/<summary\b[\s\S]*?<\/summary>/gi, "")
        .replace(/<!\[CDATA\[[\s\S]*?\]\]>/g, "");
}
function layLienKet(khoiTho) {
    const khoi = boThanBai(khoiTho);
    const than = lay(khoi, "link");
    if (than)
        return than;
    const ds = [...khoi.matchAll(/<link\b([^>]*)\/?>/gi)].map((m) => m[1] ?? "");
    const doc = (thuocTinh) => ({
        rel: (thuocTinh.match(/\brel\s*=\s*["']([^"']*)["']/i)?.[1] ?? "alternate").toLowerCase(),
        href: goChu(thuocTinh.match(/\bhref\s*=\s*["']([^"']*)["']/i)?.[1] ?? ""),
    });
    const nen = ds.map(doc).filter((l) => l.href !== "");
    return nen.find((l) => l.rel === "alternate")?.href ?? nen[0]?.href ?? null;
}
/**
 * Đọc RSS 2.0, Atom, hoặc sitemap — **một hàm, tự nhận dạng**.
 *
 * Ba định dạng chứ không phải một là chuyện của thế giới thật: `moh.gov.vn` trả RSS, nhiều trang
 * Next.js trả Atom, và trang không có feed thì chỉ còn sitemap. Tách ba hàm nghĩa là ba chỗ để
 * quên một cái.
 *
 * Trả về mảng **rỗng** khi không đọc được gì — đây là một kết quả, không phải một lỗi.
 */
export function docFeed(xml) {
    const ra = [];
    const them = (url, tieuDe, ngay) => {
        const u = (url ?? "").trim();
        if (u === "" || !/^https?:\/\//i.test(u))
            return;
        ra.push({ url: u, tieuDe: (tieuDe ?? "").trim(), ngayDang: chuanHoaNgay(ngay) });
    };
    for (const m of xml.matchAll(/<item\b[\s\S]*?<\/item>/gi)) {
        const k = m[0];
        them(layLienKet(k), lay(k, "title"), lay(k, "pubDate") ?? lay(k, "dc:date"));
    }
    for (const m of xml.matchAll(/<entry\b[\s\S]*?<\/entry>/gi)) {
        const k = m[0];
        them(layLienKet(k), lay(k, "title"), lay(k, "published") ?? lay(k, "updated"));
    }
    // Sitemap: không có tiêu đề. Chấp nhận — `chuDe` sẽ lấy từ chính trang lúc research.
    for (const m of xml.matchAll(/<url\b[\s\S]*?<\/url>/gi)) {
        const k = m[0];
        them(lay(k, "loc"), null, lay(k, "lastmod"));
    }
    return ra;
}
/**
 * `<sitemapindex>` — **một sitemap trỏ tới những sitemap khác**, không phải tới bài.
 *
 * ⚠️ Đây là dạng phổ biến nhất của `/sitemap.xml` (WordPress + Yoast sinh ra đúng nó).
 * `docFeed` chỉ đọc `<url>` nên với những trang đó nó trả về **rỗng**, và màn hình báo
 * *"không tìm thấy feed hay sitemap nào đọc được"* — một câu trả lời **sai** về trang nguồn.
 *
 * Trả danh sách sitemap con để bên gọi tải tiếp **một tầng**. Không đệ quy: sitemap lồng
 * nhiều tầng là đường để một lượt quét đi mãi.
 */
export function docSitemapIndex(xml) {
    const ra = [];
    for (const m of xml.matchAll(/<sitemap\b[\s\S]*?<\/sitemap>/gi)) {
        const loc = lay(m[0], "loc");
        if (loc && /^https?:\/\//i.test(loc))
            ra.push(loc);
    }
    return [...new Set(ra)];
}
/**
 * Ngày về ISO, hoặc `null`.
 *
 * ⚠️ **Không bao giờ thay ngày hỏng bằng "bây giờ".** Một bài năm 2019 mang nhãn hôm nay sẽ đi
 * thẳng vào hàng chờ như tin mới, và không có triệu chứng nào ngoài một bài lạc thời sự trên
 * website khách hàng thật.
 */
export function chuanHoaNgay(tho) {
    const s = (tho ?? "").trim();
    if (s === "")
        return null;
    const t = Date.parse(s);
    return Number.isNaN(t) ? null : new Date(t).toISOString();
}
/** Tìm địa chỉ feed khai trong `<head>` của một trang HTML. */
export function timFeedTrongHtml(html, gocTrang) {
    const ra = [];
    for (const m of html.matchAll(/<link\b([^>]*)>/gi)) {
        const t = m[1] ?? "";
        if (!/\brel\s*=\s*["'][^"']*alternate/i.test(t))
            continue;
        if (!/\btype\s*=\s*["'][^"']*(rss|atom)\+xml/i.test(t))
            continue;
        const href = goChu(t.match(/\bhref\s*=\s*["']([^"']*)["']/i)?.[1] ?? "");
        const tuyetDoi = noiUrl(href, gocTrang);
        if (tuyetDoi !== null)
            ra.push(tuyetDoi);
    }
    return [...new Set(ra)];
}
/**
 * Ghép một `href` với trang chứa nó thành URL tuyệt đối.
 *
 * ⚠️ Viết tay thay vì `new URL(href, goc)` vì `packages/shared` là **hàm thuần, không lib DOM**
 * — `URL` không có trong kiểu ở đây, và thêm lib chỉ để ghép chuỗi là mở cửa cho cả một thế giới
 * API chạm-môi-trường vào một gói cố ý không có cái nào.
 *
 * **Đường dẫn tương đối (không bắt đầu bằng `/`) bị BỎ, không đoán.** Ghép sai một đoạn đường
 * dẫn ra một URL 404, và 404 đó sẽ được ghi lại như "không tìm thấy feed" — một câu trả lời sai
 * về trang nguồn.
 */
export function noiUrl(href, gocTrang) {
    const h = (href ?? "").trim();
    if (h === "")
        return null;
    if (/^https?:\/\//i.test(h))
        return h;
    const goc = gocTrang.match(/^(https?:)\/\/([^/?#]+)/i);
    if (!goc)
        return null;
    if (h.startsWith("//"))
        return `${goc[1]}${h}`;
    if (h.startsWith("/"))
        return `${goc[1]}//${goc[2]}${h}`;
    return null;
}
/**
 * Lọc ra **tin thật sự mới**.
 *
 * Ba lớp, và lớp thứ ba là lớp hay bị quên:
 *
 * 1. **URL chưa từng thấy** — khoá idempotency là chính URL, không bao giờ là timestamp (`AP-01`).
 * 2. **Trong cửa sổ ngày** — bài cũ trong feed không phải tin mới.
 * 3. **Ngày `null` KHÔNG được coi là mới.** Sitemap thường thiếu `lastmod`; nhận hết nghĩa là
 *    lượt chạy đầu tiên nuốt trọn kho lưu trữ của trang đó thành hàng trăm chủ đề nghiên cứu.
 *    Muốn nhận thì phải nói ra bằng `nhanNgayTrong`.
 */
export function locTinMoi(tin, daBiet, bayGio, soNgay, nhanNgayTrong = false) {
    const nguong = bayGio.getTime() - soNgay * 24 * 60 * 60 * 1000;
    const thay = new Set();
    const ra = [];
    for (const t of tin) {
        if (daBiet.has(t.url) || thay.has(t.url))
            continue;
        if (t.ngayDang === null) {
            if (!nhanNgayTrong)
                continue;
        }
        else {
            const luc = Date.parse(t.ngayDang);
            if (Number.isNaN(luc) || luc < nguong)
                continue;
            // Ngày ở tương lai là dữ liệu hỏng của trang nguồn, không phải tin sắp ra.
            if (luc > bayGio.getTime() + 24 * 60 * 60 * 1000)
                continue;
        }
        thay.add(t.url);
        ra.push(t);
    }
    return ra;
}
/** Site chạy **Luồng 3**. Ba site còn lại chạy Luồng 2 — xem `SITE_CO_CATALOGUE`. */
export const SITE_NGHIEN_CUU = ["company", "miradry"];
export function laSiteNghienCuu(site) {
    return SITE_NGHIEN_CUU.includes(site);
}
/**
 * Host có trỏ về **mạng nội bộ** không.
 *
 * Cần vì `doc-tin` đi ra internet **theo địa chỉ người dùng nhập** và đi theo cả chuyển hướng:
 * một trang nguồn bị chiếm quyền có thể chuyển sang địa chỉ nội bộ của VPS — nơi đang chạy 5
 * website khách hàng thật và một CRM.
 *
 * Bản sao có chủ ý của phép kiểm trong `anh-cong-khai.ts`: cái kia hỏi *"người khác tải được
 * ảnh này không"*, cái này hỏi *"mình có nên tải cái này không"*. Cùng bảng dải địa chỉ, hai
 * câu hỏi ngược chiều.
 */
export function laHostNoiBo(host) {
    const h = (host ?? "").toLowerCase().replace(/^\[|\]$/g, "");
    if (h === "" || h === "localhost" || h.endsWith(".localhost"))
        return true;
    if (h === "::1" || h.startsWith("fc") || h.startsWith("fd") || h.startsWith("fe80"))
        return true;
    if (/\.(local|internal|localdomain|home|lan|test|example|invalid)$/.test(h))
        return true;
    const so = h.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
    if (!so)
        return false;
    const [a, b] = [Number(so[1]), Number(so[2])];
    if (a === 127 || a === 0 || a === 10)
        return true;
    if (a === 172 && b >= 16 && b <= 31)
        return true;
    if (a === 192 && b === 168)
        return true;
    if (a === 169 && b === 254)
        return true;
    return false;
}
/**
 * URL này có an toàn để AutoIME **tự đi tải** không.
 *
 * Chặn hai thứ: giao thức không phải http(s), và host nội bộ. Không thay được cho một phép kiểm
 * IP sau khi phân giải DNS — nhưng nó chặn ca đơn giản nhất, và phải gọi lại **sau mỗi chuyển
 * hướng**, không chỉ trước lời gọi đầu.
 */
export function taiDuocKhong(url) {
    const m = url.match(/^(https?):\/\/([^/?#]+)/i);
    if (!m)
        return false;
    return !laHostNoiBo((m[2] ?? "").split(":")[0] ?? "");
}
/* ── Nhịp research: 3 ngày một lượt, quét tin thì hằng ngày ────────────── */
/**
 * Số ngày giữa hai lượt research **trả phí**. Lynust chốt 10/09/2026.
 *
 * ⚠️ **Không áp cho lượt quét tin.** Quét là $0 và nó tích tin lại; giãn quét ra 3 ngày thì tin
 * rơi khỏi cửa sổ feed là mất luôn, mà không tiết kiệm được đồng nào.
 */
export const NHIP_RESEARCH_NGAY_MAC_DINH = 3;
/**
 * Đã tới lượt research chưa.
 *
 * ⚠️ **Không dùng biểu thức cron kiểu "mỗi 3 ngày".** Cron đếm theo ngày trong tháng, nên mọi
 * tháng có số ngày không chia hết cho 3 sẽ làm nhịp nhảy một bậc ở đầu tháng — và nó nhảy **im
 * lặng**. Cách đúng: cron chạy **hằng ngày**, rồi hỏi hàm này.
 *
 * `lanCuoi === null` = chưa chạy lần nào ⇒ **chạy ngay**. Một hệ mới dựng mà đợi 3 ngày rồi mới
 * cho dấu hiệu sống là một hệ không ai biết nó có chạy hay không.
 */
export function toiLuotResearch(lanCuoi, bayGio, soNgay = NHIP_RESEARCH_NGAY_MAC_DINH) {
    if (lanCuoi === null || lanCuoi.trim() === "")
        return true;
    const t = Date.parse(lanCuoi);
    // Mốc hỏng ⇒ chạy, chứ không phải bỏ qua vĩnh viễn. Một chuỗi rác trong CaiDat không được
    // làm cả luồng đứng im mà không ai thấy.
    if (Number.isNaN(t))
        return true;
    return bayGio.getTime() - t >= soNgay * 24 * 60 * 60 * 1000;
}
/**
 * Chọn tối đa `tran` chủ đề để đọc, **ưu tiên nguồn tầng thấp** (tầng 1 chắc nhất).
 *
 * Vì sao không lấy tin mới nhất trước: một bài tổng hợp dựng trên hai bài báo ngành và bỏ qua
 * một văn bản của Bộ Y tế là một bài **yếu hơn hẳn** cho cùng số tiền. Thứ tự trong cùng một
 * tầng thì mới trước — tin cũ hơn đã có ba ngày để được đọc ở lượt trước.
 */
export function chonNguonDeDoc(chuDe, tran) {
    const xep = [...chuDe].sort((a, b) => {
        // Tầng `null` xuống cuối: không biết tầng thì không được đứng trước một nguồn đã biết.
        const ta = a.tangNguon ?? 99;
        const tb = b.tangNguon ?? 99;
        if (ta !== tb)
            return ta - tb;
        return (b.ngayDangNguon?.getTime() ?? 0) - (a.ngayDangNguon?.getTime() ?? 0);
    });
    const n = Math.max(0, tran);
    return { doc: xep.slice(0, n), boLai: xep.slice(n), conNua: xep.length > n };
}
/* ── Lấy chữ ra khỏi một trang HTML ───────────────────────────────────── */
/**
 * Rút phần chữ đáng đọc của một trang, và **cắt ở một trần cứng**.
 *
 * Đây là hàm quyết định hoá đơn: tiền của lượt research tỉ lệ **thẳng** với số ký tự gửi đi. Đo
 * được 10/09/2026 bằng `curl` từ VPS — kích thước sau khi gỡ thẻ, còn nguyên menu và chân trang:
 *
 * | Trang | Ký tự |
 * |---|---|
 * | `who.int` — một fact sheet | 48.748 |
 * | `vnexpress.net/suc-khoe` | 19.867 |
 * | `suckhoedoisong.vn` | 120.221 |
 * | `miradry.com` | 89.787 |
 *
 * Gửi thô 10 trang cỡ đó là **$0,6–1 một lượt**. Hai việc hàm này làm, theo đúng thứ tự:
 *
 * 1. **Ưu tiên `<article>` / `<main>`** nếu trang có — đó là phần bài, không có menu.
 * 2. **Bỏ khối điều hướng** (`nav`, `header`, `footer`, `aside`, `form`) trước khi gỡ thẻ.
 *
 * ⚠️ Không phải một bộ trích nội dung thật (kiểu Readability). Nó **không** đoán đâu là đoạn
 * chính giữa nhiều `<div>`; nó chỉ bỏ những khối mà HTML **tự khai** là không phải nội dung.
 * Trang nào không dùng thẻ ngữ nghĩa thì phần trần cứng làm nốt việc.
 */
export function chuVanBanTuHtml(html, tranKyTu) {
    let s = html ?? "";
    // Bỏ hẳn những khối không bao giờ là nội dung — kể cả phần chữ bên trong chúng.
    s = s
        .replace(/<script\b[\s\S]*?<\/script>/gi, " ")
        .replace(/<style\b[\s\S]*?<\/style>/gi, " ")
        .replace(/<noscript\b[\s\S]*?<\/noscript>/gi, " ")
        .replace(/<svg\b[\s\S]*?<\/svg>/gi, " ")
        .replace(/<head\b[\s\S]*?<\/head>/gi, " ")
        .replace(/<!--[\s\S]*?-->/g, " ");
    // Trang có `<article>` hoặc `<main>` thì đó là phần bài. Lấy khối DÀI NHẤT: nhiều trang tin
    // bọc cả danh sách "bài liên quan" trong những `<article>` nhỏ cạnh bài chính.
    const khoi = [...s.matchAll(/<(article|main)\b[\s\S]*?<\/\1>/gi)].map((m) => m[0]);
    if (khoi.length > 0) {
        s = khoi.reduce((a, b) => (b.length > a.length ? b : a));
    }
    s = s
        .replace(/<nav\b[\s\S]*?<\/nav>/gi, " ")
        .replace(/<header\b[\s\S]*?<\/header>/gi, " ")
        .replace(/<footer\b[\s\S]*?<\/footer>/gi, " ")
        .replace(/<aside\b[\s\S]*?<\/aside>/gi, " ")
        .replace(/<form\b[\s\S]*?<\/form>/gi, " ");
    // Thẻ khối thành xuống dòng, còn lại thành khoảng trắng — giữ được ranh giới đoạn.
    s = s
        .replace(/<\/(p|div|li|tr|h[1-6]|section|blockquote)>/gi, "\n")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<[^>]+>/g, " ");
    s = goChu(s.replace(/\n\s*\n+/g, "\n"));
    return s.length > tranKyTu ? s.slice(0, tranKyTu) : s;
}
/**
 * Ước tiền **một lượt research một site**, đô-la Mỹ.
 *
 * `[quy ước nội bộ — chưa kiểm chứng, 10/09/2026]` — suy từ kích thước trang đo được bằng `curl`
 * và bảng giá Sonnet 5, với quy đổi 1 token ≈ 2,5 ký tự tiếng Việt. **Không phải một số đo.**
 *
 * Ở đây vì nó đã có **hai bản sao lệch nhau**: màn hình ghi `~$0,2 mỗi site`, route ghi `0.5` cho
 * hai site. Đổi giá một chỗ thì chỗ kia nói dối — đúng hình dạng `AP-71`.
 */
export const UOC_TIEN_MOT_LUOT_RESEARCH_USD = 0.25;
//# sourceMappingURL=doc-tin.js.map